var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTmx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 100,
    viewBox: "0 0 113 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0851 65.7276L18.7339 63.808V38.1115H28.1008V34.3034H0L0.967917 38.1115H10.0851V65.7276Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5139 34.3034C54.4219 39.7523 52.3924 45.2632 49.8009 50.1548C47.5216 44.8916 45.4609 39.4427 43.0879 34.3034H33.8459V64.7678H38.7479V44.582L47.7402 64.4582L56.5139 45.0155V64.7678H65.1627V34.3034H56.5139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.965 25.6966H101.413C103.505 17.2755 104.566 8.66873 104.566 0L97.3225 2.87926C95.9799 49.195 62.7273 87.6161 18.5778 97.2136L17.6723 100C36.8433 96.0991 54.5156 86.8421 68.566 73.3437H76.965L88.018 57.6161L99.071 73.3437H112.997L94.5749 49.5356L112.965 25.6966Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9582 41.8576L79.2443 34.3034H69.6276L81.0865 49.1022C82.6164 46.8421 83.9278 44.3963 84.9582 41.8576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmx);
export default __webpack_public_path__ + "static/media/tmx.cf0b134aaa84cf75f561a88b130c09b7.svg";
export { ForwardRef as ReactComponent };